import { css } from '@emotion/css';
import { theme } from '@branchjs/neo-components';

export const draggableInputStyles = {
  icon: css`
    display: block;
  `,
  title: css`
    display: flex;
    gap: ${theme.spacing(1)};
  `,
};
